<template>
  <form class="agents-search-form row margin-bottom-2" @submit.prevent="onSearch">
    <div class="columns margin-right-2">
      <input
        v-model.trim="term"
        type="text"
        name="term"
        :placeholder="$t('AGENT_MGMT.SEARCH.FORM.TERM.PLACEHOLDER')"        
      />
    </div>
    <div class="columns margin-right-2" v-if="isAccountTypeParent">
      <multiselect
        v-model="accountSelected"
        :options="accountsSorted"
        :placeholder="$t('AGENT_MGMT.SEARCH.FORM.ACCOUNT.PLACEHOLDER')"
        track-by="id"
        label="name"
        class="no-margin multiselect-wrap--small"
      >
        <template #noResult>
          <span>{{ $t('AGENT_MGMT.SEARCH.FORM.ACCOUNT.NO_RESULTS') }}</span>
        </template>
      </multiselect>
    </div>
    <div class="columns search-tab-form-column-submit">
      <woot-submit-button
          :disabled="disabledSubmit"
          :button-text="$t('AGENT_MGMT.SEARCH.FORM.BUTTON_TEXT')"        
      />
    </div>  

  </form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  components: {},
  props: {
    onInputSearch: {
      type: Function,
      default: () => {},
    },
    onSearchSubmit: {
      type: Function,
      default: () => {},
    }
  },
  data() {
    return {
      term: this.$route.query.q ?? '',
      accountSelected: this.$route.query.account_id ?? null,
    };
  },
  computed: {
    ...mapGetters({            
      uiFlags: 'agents/getUIFlags',
      isAccountTypeParent: 'isAccountTypeParent',
      subaccounts: 'subaccounts/getSubaccounts',
      subaccountUiFlags: 'subaccounts/getUIFlags',
      currentAccount: 'getCurrentAccount',
    }),
    accountsSorted(){
      let accounts = this.subaccounts;
      if(this.currentAccount){
        accounts = [...accounts, this.currentAccount];
      }
      return [...accounts].sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );
    },
    disabledSubmit() {      
      return this.uiFlags.isFetching;
    },
  },
  watch: {
    subaccounts(newValue, oldValue){
      if(newValue.length > 0 && oldValue.length == 0 && this.accountSelected && typeof this.accountSelected != 'object'){
        const accountSelected = this.accountsSorted.find(s => s.id == this.accountSelected);
        if(accountSelected){
          this.accountSelected = accountSelected;
        }else{
          this.accountSelected = null;
        }
      }
    }  
  },
  mounted() {
    if(this.isAccountTypeParent){
      this.$store.dispatch('subaccounts/get');
    }
  },
  methods: {
    onSearch() {
      this.onSearchSubmit({
        q: this.term,
        account_id: this.accountSelected?.id ?? null,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.agents-search-form{
    align-items: center;
    .columns{
      width: calc(100% - 100px);
      input, .multiselect-wrap--small .multiselect{
        margin: 0;
      }      
      &.search-tab-form-column-submit{
        max-width: 100px;
      }      
    }
  }
</style>